import axios, { AxiosRequestHeaders } from 'axios';
import qs from 'qs';
import requestInterceptor from './requestInterceptor';
import responseInterceptor from './responseInterceptor';

const randomNumberGenerator = () => {
    //define a variable consisting alphabets in small and capital letter
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz1234567890';
    const stringLength = 36;
    let randomString = '';

    //loop to select a new character in each iteration
    for (let i = 0; i < stringLength; i++) {
        const randomNumber = Math.floor(Math.random() * characters.length);
        randomString += characters.substring(randomNumber, randomNumber + 1);
    }
    return randomString;
};

export const CsrfHeaderAndCookieName = 'x-csrf-token';

export const getCsrfTokenValue = () => {
    const token = `CS${randomNumberGenerator()}`;
    document.cookie = `${CsrfHeaderAndCookieName}=${token}; secure; path=/`;
    return token;
};

// *********************************************************************************
// Do NOT include 'X-CSRF-TOKEN': getCsrfTokenValue()
// It causes problem for fileupload api call.
// **********************************************************************************

const headers: Partial<AxiosRequestHeaders> = {
    'Content-Type': 'application/json;charset=UTF-8',
    accept: 'application/json',
};

const instance = axios.create({
    headers,
    paramsSerializer: (parameters) => qs.stringify(parameters, { arrayFormat: 'brackets' }),
});

function initInterceptors() {
    requestInterceptor();
    responseInterceptor();
}

initInterceptors();

export { instance as api };
